var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toggle-button',{attrs:{"isset":_vm.archived,"color":"grey","issetText":"Archive","issetIcon":"archived","reverseText":"Unarchive","reverseIcon":"unarchive"},on:{"toggle":_vm.toggleArchive}})
}
var staticRenderFns = []

export { render, staticRenderFns }